const itemStatus = {
  SERVE_UP: 'serve-up', // 起菜, use hyphen to fit revamp's naming
  SERVE_LATER: 'serve-later', // 叫起 (hold until 起菜), use hyphen to fit revamp's naming
};

export default itemStatus;
